module.exports = __webpack_public_path__ + "img/suppor.22aafa87.png";